import _ from 'lodash';

export const fieldArrayHasErrors = (errors) =>
  errors && Object.values(errors).filter((error) => !_.isEmpty(error)).length > 0;
